import PropTypes from 'prop-types';
import { Box, Button, CircularProgress } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { Icon } from "@iconify/react";
import React from "react";
import { useSelector } from "react-redux";
import { callApi } from "src/utils/apiCall";
import { getStyles } from "./styles";

const AddMediaButtons = ({ thread, leadDetails }) => {
    const styles = getStyles(useTheme());
    const { practiceId } = useSelector(
        (state) => ({
            practiceId: state?.practiceTreatmentList?.practiceId,
        })
    );
    const [addMediaControl, setAddMediaControl] = React.useState({
        "sample-url": {
            loading: false,
            success: false
        }
    });
    const handleMediaSave = async (threadData) => {
        const mediaUrl = threadData?.media_file;
        const mediaId = threadData?.id;
        if (!mediaId) return;
        setAddMediaControl(prvObj => ({ ...prvObj, [mediaId]: { loading: true, success: false } }));
        try {
            await callApi(
                `/api/v1/practices/${practiceId}/leads-media/`,
                'POST',
                {
                    "lead": leadDetails?.id,
                    "remote_url": mediaUrl,
                    "media": mediaUrl,
                    "description": threadData?.whatsapp_media_mime_type,
                    "channel": "WHATSAPP",
                    "content_type": "whatsappmessage",
                    "object_id": threadData?.id
                }
            );
            setAddMediaControl(prvObj => ({ ...prvObj, [mediaId]: { loading: false, success: true } }));
        } catch (_) {
            setAddMediaControl(prvObj => ({ ...prvObj, [mediaId]: { loading: false, success: false } }));
        }
    }

    const mediaId = thread?.whatsapp_message_media?.id;
    const status = addMediaControl?.[mediaId];
    const isSuccess = status?.success;
    const isLoading = status?.loading;

    let label = 'Save to Lead';
    if (isLoading) label = 'Saving...';
    else if (isSuccess) label = 'Saved — Add Again?';

    return (
        <Button
            size="small"
            sx={{
                ...styles.addMediaBtn,
                ...(isSuccess ? styles.addMediaBtnSuccess : {}),
            }}
            onClick={() => {
                if (!isLoading) handleMediaSave(thread?.whatsapp_message_media);
            }}
            disabled={isLoading}
        >
            {isLoading ? (
                <CircularProgress size={12} color="inherit" />
            ) : (
                <Icon
                    icon={isSuccess ? "mdi:check-circle-outline" : "mdi:image-plus-outline"}
                    width={14}
                    height={14}
                />
            )}
            <Box component="span">{label}</Box>
        </Button>
    );
};

AddMediaButtons.propTypes = {
    thread: PropTypes.object.isRequired,
    leadDetails: PropTypes.object.isRequired,
};

export default AddMediaButtons;